import { Col, Row } from 'reactstrap';
import Split from '../../Shared/Split';

const PartnerInfo = ({ title, locked, button, children }) => (
    <Row className="mb-4">
        <Col>
            <Split className="border-bottom mb-2">
                <h5 className="op-7">{title}</h5>
                {!locked && button}
            </Split>
            {children}
        </Col>
    </Row>
);

export default PartnerInfo;
